import React from "react";
import { i18n, isEn, isJa, _t } from "app/i18n/i18n";
import { setPreference } from "pages/preferences/preferencesActions";
import { useDispatch } from "react-redux";
import { UI_LANG } from "redux/slices/api/initialisePreferences";
import { Button } from "react-bootstrap";
import { A } from "lib/routing";
import { FaIcon } from "lib/FaIcon";
import { miscSlice } from "redux/slices/miscSlice";
import { AccountDropdown } from "../AccountDropdown";
import "./TopLinksBar.scss";

export function TopLinksBar() {
  return (
    <header className="d-none d-sm-flex align-items-center overflow-x-auto bg-white text-nowrap justify-content-end">
      <Links />
      <LanguageToggle />
      <AccountDropdown />
      <PreferencesButton />
    </header>
  );
}

function Links() {
  const lang = i18n.getLanguage();

  return (
    <span className="top-link h7 mr-5 text-muted">
      <A to={`/Home?reportTypes.${lang}=ESG`} className="ml-3 pl-3">
        {_t("ESG")}
      </A>
      <A to="/Analyst_Directory" className="ml-3 pl-3 border-left">
        {_t("Analysts")}
      </A>
      <A to="/Equity_Coverage" className="ml-3 pl-3 border-left">
        {_t("Coverage")}
      </A>
      <A to="/FAQ" className="ml-3 pl-3 border-left">
        {_t("FAQ")}
      </A>
      <A to="mailto: grpsupport@nomura.com" className="ml-3 pl-3 border-left">
        {_t("Nomura Support")}
      </A>
    </span>
  );
}

function LanguageToggle() {
  const dispatch = useDispatch();

  const onClick = (lang) => {
    dispatch(setPreference({ key: UI_LANG, value: lang }, true));
    i18n.setLanguage(lang);
  };

  return (
    <div className="mr-4">
      <Button
        variant={`primary-outline mr-1 px-0 btn-sm ${isEn() && "font-weight-bold"}`}
        onClick={() => onClick("en")}
      >
        EN
      </Button>
      /
      <Button
        variant={`primary-outline ml-1 px-0 btn-sm ${isJa() && "font-weight-bold"}`}
        onClick={() => onClick("ja")}
      >
        JP
      </Button>
    </div>
  );
}

function PreferencesButton() {
  const dispatch = useDispatch();
  return (
    <Button
      variant="primary-outline text-primary mr-2"
      onClick={() => dispatch(miscSlice.actions.set({ key: "showPreferencesDialog", value: true }))}
    >
      <FaIcon icon="fa-fw fa fa-cog align-middle fa-lg" />
    </Button>
  );
}
